<template>
    <div style="padding: 10px 10px 10px 0;">
        <el-tabs v-model="selectForm.dutyType" @tab-click="handleClick">
            <el-tab-pane v-for="item in typeList" :label="item.text" :name="item.value"></el-tab-pane>
        </el-tabs>

        <el-form :inline="true" :model="selectForm" ref="selectForm">
            <el-form-item label="关键字(备注)" prop="remark">
                <el-input size="small" v-model="selectForm.remark" placeholder="请输入关键字(备注)"></el-input>
            </el-form-item>
            <el-form-item label="上传人" prop="person">
                <el-input size="small" v-model="selectForm.person" placeholder="请输入上传人"></el-input>
            </el-form-item>
            <el-form-item label="日期" prop="queryDate">
                <el-date-picker clearable size="small" v-model="queryDate" type="daterange" align="right" unlink-panels
                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" @click="getAll">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" @click="$refs.selectForm.resetFields(); query();">重置</el-button>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" @click="addRow">新增</el-button>
            </el-form-item>
        </el-form>
        <!-- 表格 -->
        <el-table v-loading="loading" :data="data1" style="width: 100%">
            <el-table-column prop="dutyDate" label="值班日期" align="center"></el-table-column>
            <el-table-column prop="person" label="上传人" align="center"></el-table-column>
            <el-table-column prop="updateTime" label="上传时间" align="center"></el-table-column>
            <!-- <el-table-column prop="photoUrl" label="图片" align="center"></el-table-column> -->
            <el-table-column prop="remark" label="备注" align="center"></el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button type="text" @click="view(scope.row)">查看附件</el-button>
                    <el-button type="text" @click="edit2(scope.row)">编辑</el-button>
                    <el-button type="text" @click="del2(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination v-if="totalNum > 0" @size-change="sizeChange" @current-change="currentChange"
            :page-sizes="[10, 20, 30, 40]" :page-size="selectForm.rows" layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum" style="margin-top: 10px;">
        </el-pagination>

        <el-dialog :title="title" :visible.sync="show" width="500px"  :modal-append-to-body="false" @close="showClose">
            <el-form label-width="100px" :model="form2" ref="form2">
                <el-form-item label="值班日期" prop="dutyDate">
                    <el-date-picker size="small" v-model="form2.dutyDate" type="date" placeholder="选择日期"
                        value-format="yyyy-MM-dd" style="width: 100%;" />
                </el-form-item>
                <el-form-item label="上传类型" prop="dutyType">
                    <el-select style="width:100%" v-model="form2.dutyType" placeholder="请选择班次类型">
                        <el-option size="small" v-for="item in typeList" :label="item.text"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="上传人" prop="person">
                    <el-input size="small" v-model="form2.person" disabled placeholder="请输入上传人"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="form2.remark" type="textarea" :rows="2" placeholder="请输入备注">
                    </el-input>
                </el-form-item>
                <el-form-item label="上传图片" prop="photoUrl">
                    <el-upload accept=".png,.jpg,.jpeg" class="upload-demo" action="/api/admin/dutyInfo/uploadFile"
                        :on-success="handleAvatarSuccess" :headers="headerData" :show-file-list="false">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>

                    <div style="display: flex;flex-wrap:wrap;">
                        <div v-for="item in imgList"
                            style="border:1px solid #DCDFE6;width:100px;height:100px;margin-right:10px;margin-bottom: 10px;">
                            <el-image style="width:100%;height:100%;" :src="item" alt=""
                                @click="imgClick(item)"></el-image>
                        </div>
                    </div>
                    <el-dialog :visible.sync="dialogVisible" append-to-body>
                        <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="show = false;">取 消</el-button>
                <el-button size="small" type="primary" @click="submit2">确 定</el-button>
            </span>
        </el-dialog>


        <el-dialog title="查看附件" :visible.sync="viewShow" width="500px"  :modal-append-to-body="false">
            <div style="display: flex;flex-wrap:wrap;">
                <div v-for="item in imgList"
                    style="border:1px solid #DCDFE6;width:100px;height:100px;margin-right:10px;margin-bottom: 10px;">
                    <el-image style="width:100%;height:100%;" :src="item" alt="" @click="imgClick(item)"></el-image>
                </div>
            </div>
            <el-dialog :visible.sync="dialogVisible" append-to-body>
                <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="viewShow = false;">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import publicExport from '../../assets/js/publicExport.js';
export default {
    data() {
        return {
            viewShow: false,
            dialogVisible: false,
            dialogImageUrl: "",
            imgList: [],
            // 请求头携带token
            headerData: {
                Authorization: localStorage.access_token
            },
            dayList: [],
            nightList: [],
            title: "",
            form2: {
                "dutyDate": "",
                "dutyType": "",
                "id": null,
                "person": sessionStorage.getItem("name"),
                "photoUrl": "",
                "remark": "",
                "updatePerson": "",
            },
            typeList: [
                {
                    "value": "值班记录表",
                    "text": "值班记录表"
                },
                {
                    "value": "值班抄表记录",
                    "text": "值班抄表记录"
                },
                {
                    "value": "每日运行记录",
                    "text": "每日运行记录"
                }
            ],
            totalNum: 0,
            loading: false,
            data1: [], //表格数据
            selectForm: { //查询条件
                page: 1, //当前页
                rows: 10, //页大小
                startTime: "",
                endTime: "",
                remark: "",
                person: "",
                dutyType: "值班记录表",

            },
            queryDate: [], //查询日期
            show: false, //控制弹窗
            title: "新增",
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        end.setTime(start.getTime() + 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        end.setTime(start.getTime() + 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        end.setTime(start.getTime() + 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            dialogImageUrl: "",
            dialogVisible: false
        }
    },
    watch: {
    },
    methods: {
        showClose() {
            if (this.title == "新增") {
                this.delImg();
            }
        },
        delImg() {
            if (this.imgList.length != 0) {
                this.$http.get(`/api/dutyInfo/deleteFile?fileUrl=${this.imgList.toString()}`, {}).then(res => {
                    if (res.data.code == 0) {
                    } else {
                    }
                })
            }


        },
        view(item) {
            let row = JSON.parse(JSON.stringify(item))
            if (row.photoUrl) {
                this.imgList = row.photoUrl.split(",");
                this.viewShow = true;
            } else {
                this.$message("暂无附件")
            }
        },
        imgClick(item) {
            this.dialogImageUrl = item;
            this.dialogVisible = true;
        },
        // 上传成功
        handleAvatarSuccess(res) {
            if (res.code == 0) {
                this.$message.success(res.message)
                this.imgList.push(res.data)
            } else {
                this.$message.error(res.message)
            }
            // console.log(file)
            // this.imgList.push();
        },
        addRow() {
            this.title = "新增";
            this.form2 = {
                dutyDate: "",
                dutyType: this.selectForm.dutyType,
                id: null,
                person: sessionStorage.getItem("name"),
                photoUrl: "",
                remark: "",
                updatePerson: "",
            };
            this.imgList = []
            this.show = true;
        },
        edit2(item) {
            this.title = "编辑";
            let row = JSON.parse(JSON.stringify(item))
            this.form2 = {
                dutyDate: row.dutyDate,
                dutyType: row.dutyType,
                id: row.id,
                person: row.person,
                photoUrl: this.photoUrl,
                remark: row.remark,
                updatePerson: sessionStorage.getItem("name"),
            };
            if (row.photoUrl) {
                this.imgList = row.photoUrl.split(",");
            }
            this.show = true;
        },
        submit2() {
            if (this.form2.dutyDate == "" || !this.form2.dutyDate) {
                this.$message.error("请选择值班日期")
                return
            }
            if (this.imgList.length == 0) {
                this.$message.error("请上传附件")
                return
            }
            let url = "/api/dutyInfo/insert"
            if (this.form2.id) {
                url = "/api/dutyInfo/update"
            }
            this.form2.photoUrl = this.imgList.toString();
            this.$http.post(url, this.form2).then(res => {
                if (res.data.code == 0) {
                    this.title = ""
                    this.getAll();
                    this.show = false;
                    this.$message.success("操作成功")
                } else {
                    this.$message.error("操作失败")
                }
            })
        },
        del2(row) {
            this.$confirm('确定该删除该数据吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if (row.photoUrl) {
                    this.imgList = row.photoUrl.split(",");
                }
                this.$http.delete(`/api/dutyInfo/delete?id=${row.id}`, {}).then(res => {
                    console.log(this.imgList)
                    if (res.data.code == 0) {
                        this.delImg();
                        this.getAll();
                        this.$message.success("删除成功")
                    } else {
                        this.$message.error("删除失败")
                    }
                })
            })
        },
        //时间格式化函数，此处仅针对yyyy-MM-dd hh:mm:ss 的格式进行格式化
        dateFormat: function (time) {
            var date = new Date(time);
            var year = date.getFullYear();
            /* 在日期格式中，月份是从0开始的，因此要加0
             * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
             * */
            var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
            var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
            var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
            var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
            // 拼接
            // +" "+hours+":"+minutes+":"+seconds
            return year + "-" + month + "-" + day;
        },

        query() {
            this.queryDate = [];
            this.selectForm.remark = "";
            this.selectForm.person = "";
            this.selectForm.page = 1 //查询条件
            this.getAll();
        },
        handleClick() {
            this.selectForm.page = 1 //查询条件
            this.query();
        },
        getAll() { //获取表格数据s
            this.loading = true;
            if (this.queryDate && this.queryDate.length == 2) {
                this.selectForm.startTime = this.queryDate[0]
                this.selectForm.endTime = this.queryDate[1]
            } else {
                this.selectForm.startTime = ""
                this.selectForm.endTime = ""
            }
            this.data1 = []
            this.$http.post(`/api/dutyInfo/select`, this.selectForm).then(res => {
                if (res.data.code == 0) {
                    this.data1 = res.data.data.items;
                    this.totalNum = res.data.data.totalNum;
                } else {
                    this.$message.error("查询失败")
                }
                this.loading = false;
            })
        },
        sizeChange(size) { //页大小被修改
            this.selectForm.rows = size;
            this.getAll();
        },
        currentChange(page) { //当前页被修改
            this.selectForm.page = page;
            this.getAll();
        },

    },
    created() {
        this.getAll();
    }
}
</script>

<style scoped="scoped">
.one {
    display: flex;
}

.oneItem {
    width: 100%;
    /* text-align: center; */
}

.one .is-selected {
    color: #1989FA;
}
</style>
